import React, { Component } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { Table, Input, ListGroup, ListGroupItem } from 'reactstrap';

import { ROUTES, insertIdtoUrl } from 'constants/Routes.js';
import { categoryFilter } from 'utils/categoryfilter.js';

class CategoryListing extends Component {

  render() {
    let $categoryList = this.props.categories.map((category) => {
      return (
        <tr key={category.id}>
          <td>
            <NavLink activeClassName="navActive" onClick={this.props.setName.bind(this,category.name)} to={insertIdtoUrl(ROUTES.CATEGORIES_QUESTIONS, category.id)}>
              {category.name}</NavLink>
          </td>
        </tr>
      )
    })
    return (
      <Table hover id="categoryTable" className='styled-box-shadow left-nav-box'>
        <thead>
          <tr>
            <th>Surveys</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>
              <form autocomplete="off">
                <input className="form-control bg-light" type="search" placeholder="Search" id="categoryInput" onChange={categoryFilter} />
              </form>
            </th>
          </tr>
          {$categoryList}
        </tbody>
      </Table>
    );
  }
}

export default CategoryListing;



// WEBPACK FOOTER //
// ./src/components/questions/display/QuestionsCategory.js